<template lang="pug">
  hr.v-divider.theme--light(:style="{margin: `0 0 0 ${inset}px`}")
</template>
<script>
export default {
  name: 'Divider',
  props: { inset: {} },
};
</script>